var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('app-errors'),(_vm.requireAuth)?_c('div',{attrs:{"id":"auth-content"}},[_c('app-nav'),(_vm.$userInfo && _vm.$user && _vm.$user.permissions && _vm.$company)?_c('router-view',{staticClass:"app-content"}):_vm._e()],1):_c('div',[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }